import { roundToPrecision } from './number';

export function formatPrice(value: number, precision = 0, currency = '€'): string {
    const formattedValue = roundToPrecision(value, precision).toLocaleString('fr');

    return `${formattedValue}\xa0${currency}`;
}
